import getPeople from '../../data_management/getPeople'
import markScreenSelected from '../../gateways/browser/mark_screen_selected';

const PeopleController = function ($scope, initialDataInteractor) {
  this.loaded = false;

  initialDataInteractor.ensureInitializedSession().then(() => {
      this.coachees = getPeople(initialDataInteractor);

      this.coachees.sort((a, b) => {
        if (a.name.toUpperCase() < b.name.toUpperCase()) {
          return -1
        } else if (a.name.toUpperCase() > b.name.toUpperCase()) {
          return 1
        } else {
          return 0
        }
      });

      this.loaded = true;
      $scope.$digest();
  });

  markScreenSelected("people");

  this.onPersonCreation = function (newPerson) {
    this.coachees.push(newPerson);
    $scope.$digest();
  };
};

export default {
  name: 'PeopleController',
  fn: PeopleController
};